import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

import loginImage from "../assets/Relax.png";
import wavingHand from "../assets/waving-hand-svgrepo-com.svg";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      setError(null);
      
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/auth/login`,
        {
          email: formData.email,
          password: formData.password
        }
      );

      if (response.data) {
        console.log(response.data)
        localStorage.setItem("accessToken", response.data.data.session.access_token);
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
        navigate("/dashboard");
      }
    } catch (err) {
      console.error("Login error:", err);
      toast.error("Incorrect login ID or password", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setError("Incorrect login ID or password");
    } finally {
      setIsLoading(false);
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <ToastContainer />

      <div className="container w-full mx-auto max-w-[96rem] h-full overflow-hidden">
        <div className="flex flex-col sm:flex-row w-full h-full items-center justify-between">
          {/* Left Section - Login Form */}
          <div className="w-full sm:w-1/2 p-12 flex items-center justify-center">
          <div className="p-8 w-full max-w-sm sm:w-full shadow-md rounded-md text-lg">
            <h2 className="w-full text-xl text-center flex gap-1 md:text-3xl items-center justify-center font-bold mb-2">
              Hello There! <span><img className="h-8" src={wavingHand} /></span>
            </h2>
            <form onSubmit={handleSubmit} className=" space-y-2">
                {error && (
                  <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded relative" role="alert">
                    <span className="block sm:inline">{error}</span>
                  </div>
                )}
              <div>
              <label>Login Id</label>
              <input
                type="email"
                name="email"
                placeholder="Enter email address"
                value={formData.email}
                onChange={handleChange}
                    className={`appearance-none rounded-none relative block w-full px-3 py-2 border ${
                      error ? 'border-red-300' : 'border-gray-300'
                    } placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-orange-500 focus:border-orange-500 focus:z-10 sm:text-sm`}
                    disabled={isLoading}
              />
               </div>
              <div>
              <label>Password</label>
              <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={handleChange}
                      className={`appearance-none rounded-none relative block w-full px-3 py-2 border ${
                        error ? 'border-red-300' : 'border-gray-300'
                      } placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-orange-500 focus:border-orange-500 focus:z-10 sm:text-sm`}
                      disabled={isLoading}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-3 flex items-center text-gray-600 hover:text-gray-800"
            >
              {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
            </button>
          </div>
<Link className="flex py-2 justify-end text-sm text-blue-500 text-end w-full" href="/forgot-password">Forgot Password?</Link>
             </div>
            <button
              type="submit"
              disabled={isLoading}
                  className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ${
                    isLoading ? 'bg-orange-400 cursor-not-allowed' : 'bg-orange-500 hover:bg-orange-600'
                  } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors`}
                >
                  {isLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Signing in...
                    </>
                  ) : (
                    'Sign in'
                  )}
            </button>
            <p className="text-center text-sm text-gray-500">Don't have an account?<Link className="text-blue-500 hover:underline" to="/signup">Signup</Link></p>
          </form>
        </div>
        </div>

        {/* Right Section - Background with Image */}
        <div className="relative hidden md:flex items-center justify-center h-full w-1/2">
          {/* Image Wrapper */}
          <div className="h-full w-full rounded-lg overflow-hidden flex items-center justify-center">
            <img src={loginImage} alt="Login Illustration" className="h-full w-full object-cover" />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Login;
